import { TextField } from '@material-ui/core';
import React, {useEffect, useState} from 'react';
import {useQueryClient} from "react-query";

import { ComboSelect, FormDialog }from "../../../../controls";
import { useUpdateTripLegChecklist } from '../../../../services/trips';
import Validator from "../../validators/TripLegChecklistItemValidator";

const TripLegChecklistItemDialog = (props) => {

  const classes = props.classes;
  const SystemData = props.systemData;
  const queryClient = useQueryClient();
  const afterSave = props.afterSave;

  const eventBus = SystemData.eventBus;

  const [dialogState, setDialogState] = useState({
    showDialog: false,
    canEdit: false,
    item: {},
    tripLegUuid: null,
    title: ''
  });

  const DisplayDialog = (props) => {
    const extraKeys = [dialogState.tripLegUuid||''];
    const handleUpdateTripLegChecklist = useUpdateTripLegChecklist();
  
    const handleUpdateItem = (updatedItem) => {
      setDialogState({...dialogState, item: updatedItem});
      return updatedItem;
    }

    if (dialogState.item) {
      return (
        <FormDialog
          title={dialogState.title}
          message=""
          open={dialogState.showDialog}
          record={dialogState.item}
          dialogOptions={{maxWidth: "sm", fullWidth: false}}
          classes={classes}
          validator={Validator}
          buttons = {{
            save:{icon: "check_circle", key: "Update", label: "Update", color: "primary", disabled: (status)=>{return status.error}},
            cancel:{icon: "cancel", key: "Cancel", label: "Cancel", color: "primary"}
          }}
          onChange={(state) => {
            if (state.buttonPressed === "save") {            
              const updatedItem = state.record;
              const updatedRecord = handleUpdateItem(updatedItem);
              handleUpdateTripLegChecklist.mutate({
                record: updatedRecord,
                extraKeys,
                resolve: () => {
                  setDialogState({...dialogState, showDialog: false, item: null, handleSave: null});
                  if (afterSave) {
                    afterSave();
                  }
                  if (typeof props.onClose === 'function') {props.onClose()}
                },
                reject: (err) => {
                  SystemData.openAlert("Error Saving Checklist", "An unexpected error has occurred while saving the checklist item.");
                }
              });
            } else {
              setDialogState({...dialogState, showDialog: false, item: null, handleSave: null});
              if (typeof props.onClose === 'function') {props.onClose()}
            }
          }}
        >
          <div style={{display: "block", width: 150}} checkChildren={true}>
            <ComboSelect
              id="status"
              label="Status"
              group="GENERAL CHECKLIST STATUS TYPES"
              subGroup={dialogState.item?.checklistStatusType||"DEFAULT"}
            />
          </div>
          {dialogState.item.allowNotes
          ? <div style={{display: "block", width: "100%", minWidth: 400, marginTop: 15}} checkChildren={true}>
              <TextField
                id="serviceNotes"
                label="Note"
                placeholder={`${dialogState.item.itemName} note`}
                multiline
                InputLabelProps = {{shrink: true}}
              />
            </div>
          : null
          }
        </FormDialog>
      )
    } else {
      return (<></>);
    }
  }

  useEffect(()=> {
    const open = async (params) => {
      const {title, canEdit, tripLegUuid, item} = params;
      setDialogState({...dialogState, showDialog:true, canEdit, title, tripLegUuid, item});
    }
    eventBus.bind("TripLegChecklistItemDialog.open", open);
    return () => {
      eventBus.unbind("TripLegChecklistItemDialog.open", open);
      queryClient.invalidateQueries("TripLegs");
    }
  }, [dialogState, eventBus, queryClient]);

  if (dialogState.showDialog) {
    return (
      <DisplayDialog />
    )
  }
  return (<></>);
}

export default TripLegChecklistItemDialog;
